<div class="data-table widget-content">

  <div class="table-search">
    <input #searchBox class="form-control" placeholder="Search..." pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')">
  </div>

  <div class="data-table table-container larger-font">
    <p-table #dt [value]="clientsProfiles"
             dataKey="DataKey"
             selectionMode="single"
             [paginator]="true"
             [rows]="10"
             [pageLinks]="10"
             [loading]="loading"
             loadingIcon="fa fa-spinner"
             responsiveLayout="scroll"
             [globalFilterFields]="getGlobalFilterFields()">

      <ng-template pTemplate="header">
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.Field">
            {{col.Header}}
            <p-sortIcon [field]="col.Field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-profile let-row>
        <tr (click)="onRowSelect(row)" class="ui-selectable-row">
          <td>{{profile?.name}}</td>
          <td>{{profile?.profile?.name}}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <mojo-table-paginator #paginator *ngIf="!loading" [table]="dt"></mojo-table-paginator>
</div>
